import React from 'react';

interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  action?: {
    text: string;
    onClick: () => void;
    variant?: 'primary' | 'secondary';
  };
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: {
    container: 'py-8',
    icon: 'text-3xl',
    title: 'text-base font-medium',
    description: 'text-sm'
  },
  md: {
    container: 'py-12',
    icon: 'text-4xl',
    title: 'text-lg font-medium',
    description: 'text-base'
  },
  lg: {
    container: 'py-16',
    icon: 'text-5xl',
    title: 'text-xl font-semibold',
    description: 'text-lg'
  }
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  size = 'md'
}) => {
  const sizeClass = sizeClasses[size];

  return (
    <div className={`text-center ${sizeClass.container}`}>
      <i className={`${icon} ${sizeClass.icon} text-gray-400 mb-4`}></i>
      <h3 className={`${sizeClass.title} text-gray-900 mb-2`}>{title}</h3>
      <p className={`${sizeClass.description} text-gray-600 mb-6`}>{description}</p>
      
      {action && (
        <button
          onClick={action.onClick}
          className={`px-4 py-2 rounded-lg font-medium transition-colors ${
            action.variant === 'secondary'
              ? 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              : 'bg-blue-600 text-white hover:bg-blue-700'
          }`}
        >
          {action.text}
        </button>
      )}
    </div>
  );
};